import React from "react";
import { Link } from "react-router-dom";
import css from "./SpringPicksSection.module.css";

import garden from "../../assets/images/Gardenstart.png";
import greens from "../../assets/images/freshgreen.png";
import honey from "../../assets/images/localhoney.png";
import bread from "../../assets/images/bakedgoods.png";
import eggs from "../../assets/images/farmfresheggs.png";
import flower from "../../assets/images/flower.png";


const items = [
  {
    image: garden,
    title: "Plants & Seedlings",
    description: "Healthy starter plants ready for your spring garden.",
    category_url: "/s?pub_categoryLevel1=plants-and-seedlings",
  },
  {
    image: greens,
    title: "Vegetables",
    description: "Crisp, locally harvested greens picked at peak freshness.",
    category_url: "/s?pub_categoryLevel1=vegetables",
  },
  {
    image: honey,
    title: "Honey",
    description: "Small-batch honey and handcrafted pantry staples.",
    category_url: "/s?pub_categoryLevel1=honey",
  },
  {
    image: bread,
    title: "Baked Goods",
    description: "Freshly baked breads and seasonal treats from local makers.",
    category_url: "/s?pub_categoryLevel1=baked-goods",
  },
  {
    image: eggs,
    title: "Farm Fresh Eggs",
    description: "Pasture-raised eggs from trusted local farms.",
    category_url: "/s?pub_categoryLevel1=Fresh_Local_Eggs",
  },
  {
    image: flower,
    title: "Fresh Flowers",
    description: "Seasonal blooms and ready-to-plant favorites from local growers.",
    category_url: "/s?pub_categoryLevel1=fresh-flowers",
  }
];

const SpringPicksSection = () => {
  return (
    <div className={css.sectionWrapper}>
      <div className={css.container}>

        <div className={css.header}>
          <Link to="/s" className={css.customBtn}>Browse Listings page</Link>
          <p className={css.subtitle}>
            Fresh seasonal favorites from trusted local growers.
          </p>
        </div>

        <div className={css.grid}>
          {items.map((item, index) => (
            <div key={index} className={css.card}>
              <img src={item.image} alt={item.title} className={css.image} />

              <h3 className={css.title}>{item.title}</h3>

              <p className={css.description}>
                {item.description}
              </p>

              <Link to={item.category_url} className={css.button}>
                Browse ➜
              </Link>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default SpringPicksSection;
